import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Import translation files
import translationDE from "./locales/de/translation.json";
import translationEN from "./locales/en/translation.json";
import translationES from "./locales/es/translation.json";

const resources = {
  de: {
    translation: translationDE,
  },
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};

// Get browser language (base language code only, e.g., 'en' from 'en-US')
const getBrowserLanguage = (): string => {
  const browserLang = navigator.language || (navigator as any).userLanguage;
  const langCode = browserLang.split("-")[0].toLowerCase();
  // Check if we support this language
  return resources[langCode as keyof typeof resources] ? langCode : "en";
};

// Configure language detection
const detectionOptions = {
  // Detection order: navigator first (we'll manage localStorage ourselves)
  order: ["navigator"],
  // Don't cache automatically - we'll handle this
  caches: [],
  // Don't use cookies
  excludeCacheFor: ["cimode"],
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    detection: detectionOptions,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    // Return the key itself when translation is missing (for debugging)
    parseMissingKeyHandler: (key: string) => {
      console.warn(`[i18n] Missing translation key: ${key}`);
      return key;
    },
    // Use the key as fallback when translation is missing
    returnEmptyString: false,
    returnNull: false,
  });

// Initial language detection on page load
const browserLang = getBrowserLanguage();
const storedLang = localStorage.getItem("widget-language");

// If browser language differs from stored language, update to browser language
if (browserLang !== storedLang) {
  localStorage.setItem("widget-language", browserLang);
  if (i18n.language !== browserLang) {
    i18n.changeLanguage(browserLang);
  }
}

export default i18n;
